import { render, staticRenderFns } from "./LoginVerification.vue?vue&type=template&id=96e8b04a&scoped=true&"
import script from "./LoginVerification.vue?vue&type=script&lang=js&"
export * from "./LoginVerification.vue?vue&type=script&lang=js&"
import style0 from "./LoginVerification.vue?vue&type=style&index=0&id=96e8b04a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96e8b04a",
  null
  
)

export default component.exports